var map = {
	"./backtop.svg": 2419,
	"./copy.svg": 4392,
	"./good.svg": 916,
	"./qq.svg": 4065,
	"./save.svg": 5620,
	"./search.svg": 6455,
	"./share.svg": 2276,
	"./star.svg": 2319,
	"./user.svg": 4218,
	"./wechat.svg": 7513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;